// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"b40413a6","616":"f80e9d89","794":"2699d61c"}[chunkId] + ".chunk.js";
};